import { render } from "./RmaElementModal.vue?vue&type=template&id=512d9d1e&scoped=true&ts=true&lang=pug"
import script from "./RmaElementModal.vue?vue&type=script&lang=ts"
export * from "./RmaElementModal.vue?vue&type=script&lang=ts"

import "./RmaElementModal.vue?vue&type=style&index=0&id=512d9d1e&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-512d9d1e"]])

export default __exports__